import { render, staticRenderFns } from "./ModelCourse.vue?vue&type=template&id=a0208a32&"
import script from "./ModelCourse.vue?vue&type=script&lang=js&"
export * from "./ModelCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports